import { Button } from 'antd';
import * as React from 'react';
import { UserOutlined as User } from '@ant-design/icons';
import CustomIcon from './images/icon-pricing-plan-custom.svg';
import UpgradeCircle from './images/ic-upgrade-circle.svg';
import FeatureColumn from './FeatureColumn';
import styles from './PlanCardColumn.module.css';
import * as translations from './strings';
import * as columnTranslations from './stringsColumnPlans';
import { getLangKey } from 'models/Language';
import { HelpModuleButton } from 'utils/HelpArticleButton';

const strings = translations[getLangKey()];
const columnStrings = columnTranslations['en'];

const customPlanFeatures = [
  columnStrings.customMemberLimit,
  columnStrings.dedicatedSuccessManager,
  columnStrings.onboardingAndTraining
];

const CustomPlanColumn = ({
  pricing2026Variant
}: {
  pricing2026Variant: boolean;
}) => {
  const membersBadgeText = pricing2026Variant
    ? strings.customMember
    : 'Members: Custom';
  const description = pricing2026Variant
    ? columnStrings.descriptionCustom
    : strings.descriptionCustom;
  const featuresHeader = pricing2026Variant
    ? columnStrings.customFeaturesHeaderVariant
    : columnStrings.customFeaturesHeader;

  return (
    <div className={styles.card}>
      <div className={styles.planName}>
        {strings.customHeader}
        <CustomIcon className={styles.planIcon} />
      </div>

      <div className={styles.priceSection}>
        <div className={styles.priceRow}>
          <span className={styles.customPriceText}>Let&apos;s Talk</span>
        </div>
        <div className={styles.contactUsWrapper}>
          <Button shape="round">
            <HelpModuleButton>{strings.customContactUs}</HelpModuleButton>
          </Button>
        </div>
      </div>

      <div className={styles.membersBadge}>
        <div className={styles.membersBadgeIcon}>
          <User style={{ fontSize: '9px', color: 'var(--colorText)' }} />
        </div>
        <span className={styles.membersBadgeText}>{membersBadgeText}</span>
      </div>

      <p className={styles.description}>{description}</p>

      <div className={styles.divider} />

      <div className={styles.features}>
        <div className={styles.featureHeader}>{featuresHeader}</div>
        <ul>
          {customPlanFeatures.map((feature: string) => (
            <FeatureColumn
              key={feature}
              item={{ type: 'feature', text: feature, variant: true }}
            />
          ))}
          <li>
            <span className={styles.featureRow}>
              <UpgradeCircle className={styles.featureIcon} />
              <span className={styles.featureText}>{columnStrings.singleSignOn}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CustomPlanColumn;
